import { Component} from '@angular/core';


import { HttpClient} from '@angular/common/http';
import { AuthService } from '../../_services';

@Component({
  selector: 'vts-reports',
  templateUrl: './vtsReport.component.html', 
})

export class VtsReportsComponent {
  constructor(private HttpClient : HttpClient,private auth : AuthService) { 
  }  
  ngOnInit() 
  { 
  
  }

}
 


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/vtsReport.component.ts